import { DataBean } from "../DataBean";

export class DocumentStateTypes extends DataBean {



    public async getDocumentStateTypes(args:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getDocumentStateTypes_Number", [args]);
    }
    
}